import { Component, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { Equipment, EquipmentService, SitePlant } from "../../../equipments/services/equipment.service"
import ArrayStore from "devextreme/data/array_store";
import DataSource from "devextreme/data/data_source";
import 'jspdf-autotable';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';
import { Router } from "@angular/router";
import { NotificationService } from "../../../common/component/notification/notification.service"
import { Utility } from "../../../common/service/utility"

@Component({
  selector: 'app-equipmentlist',
  templateUrl: './equipmentlist.component.html',
  styleUrls: ['./equipmentlist.component.scss']
})
export class EquipmentListComponent implements OnInit {
  @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
  readonly allowedPageSizes = [50,100,200];

  sites: SitePlant[];
  equipments: Equipment[];
  filteredEquipments: Equipment[];
  sitesDataSource: DataSource;
  selectedSite: string;
  showFilterRow: boolean;
  showHeaderFilter: boolean;
  sitesResponseReceived: boolean;
  equipmentsResponseReceived: boolean;
  isLoadPanelVisible: boolean = false

  constructor(private equipmentService: EquipmentService,
    private router: Router,
    private notificationService: NotificationService,
    private utility: Utility) {
      this.showFilterRow = true;
      this.showHeaderFilter = true;
  }

  ngOnInit(): void {
    this.isLoadPanelVisible = true;
    this.getSites();
    this.getEquipments();
  }

  getSites() {
    this.isLoadPanelVisible = true;
    this.equipmentService.getSites().subscribe({
        next: sites => {
            this.sites = sites;
            this.sites.unshift(new SitePlant());
            this.sitesDataSource = new DataSource({
              store: new ArrayStore({
                  data: sites,
                  key: 'siteId',
              })
          });
          this.sitesResponseReceived = true;
          if(this.hasAllResponseReceived()) this.isLoadPanelVisible = false;
        }, error: (error) => {
            this.notificationService.alert("error", "Error while fetching Plants", error);
            this.isLoadPanelVisible = false;
        }
    });
}

getEquipments() {
  this.isLoadPanelVisible = true;
  this.equipmentService.getEquipments().subscribe({
      next: compressedData => {
          var decompressedData = this.utility.decompressData(compressedData);
          var equipments : Equipment[] = JSON.parse(decompressedData)
          this.equipments = this.filteredEquipments = equipments;
          this.isLoadPanelVisible = false;
          this.equipmentsResponseReceived = true;
          if(this.hasAllResponseReceived()) this.isLoadPanelVisible = false;
      }, error: (error) => {
          this.notificationService.alert("error", "Error while fetching Plants", error);
          this.isLoadPanelVisible = false;
      }
  });
}

  exportExcel(e) {
    const workbook = new Workbook();    
    const worksheet = workbook.addWorksheet('Main sheet');
    exportDataGrid({
        component: this.dataGrid.instance,
        worksheet: worksheet
    }).then(function() {
        workbook.xlsx.writeBuffer()
            .then(function(buffer: BlobPart) {
                saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Equipments.xlsx');
            });
    });
    e.cancel = true; 
}

  resetFilters() {
    this.dataGrid.instance.clearFilter();
  }

  onRowDoubleClick(e) {
    var rowItem = this.filteredEquipments.filter(n => n.equipmentId == e.key);    
    this.router.navigate([`/update-equipment/${e.key}/${rowItem[0].productionFacilityId}`]);
  }

  onSaving(e) {
    this.isLoadPanelVisible = true;
  }

  onSiteValueChanged(e) {
    if(e.value == null) 
    {
      this.filteredEquipments = this.equipments;
      return;
    }
    this.filteredEquipments = this.filteredEquipments.filter(n => n.siteId == e.value);
  }

  setStateValue(rowData: any, value: any): void {
    (<any>this).defaultSetCellValue(rowData, value);
  }

  setDateCellValue(e) {
    if(e == '') return;
    return this.formatDate(e);
  }
  
  formatDate = (date) => {
    let d = new Date(date);
    let month = (d.getMonth() + 1).toString().padStart(2, '0');
    let day = d.getDate().toString().padStart(2, '0');
    let year = d.getFullYear();
    return [year, month, day].join('-');
  }

  hasAllResponseReceived(): boolean {
    return this.sitesResponseReceived && this.equipmentsResponseReceived;
  }
}
